var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:{normalItem: !_vm.isSelected, selectedItem: _vm.isSelected},on:{"click":_vm.onclick}},[_c('label',{staticClass:"title",class:{normalTitle: !_vm.isSelected, selectedTitle: _vm.isSelected}},[_vm._v(_vm._s(_vm.item.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aab6728","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FlowRadioItem.vue
// module id = null
// module chunks = 